"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setVisible;
// make a given rgba value visible
function setVisible(pixel) {
  // @ts-ignore
  pixel[3] = 255;
  // @ts-ignore
  return pixel;
}